var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconServices = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50.822,
    height: 51.529,
    viewBox: "0 0 50.822 51.529",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1564",
    "data-name": "Group 1564",
    transform: "translate(-34.92 -778.51)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_704",
    "data-name": "Path 704",
    d: "M121.185,231.831a3.869,3.869,0,0,0-4.858-.393l-10.794,7.315a4.083,4.083,0,0,0-2.522-4.2L98.66,232.8a16.553,16.553,0,0,0-12.536.035l-5.132,2.1a4.986,4.986,0,0,0-5.291-.528l-2.726,1.363a2.513,2.513,0,0,0-1.125,3.373l7.4,14.8a2.5,2.5,0,0,0,2.249,1.388,2.531,2.531,0,0,0,1.123-.265l2.726-1.363a4.958,4.958,0,0,0,2.75-4.5l11.9.259.243,0a10.949,10.949,0,0,0,6.171-1.9l14.29-9.684a3.893,3.893,0,0,0,.489-6.054ZM85.416,250.012a2.4,2.4,0,0,1-1.214,1.4l-2.684,1.342-7.356-14.711,2.683-1.342a2.421,2.421,0,0,1,3.246,1.082l5.192,10.384A2.4,2.4,0,0,1,85.416,250.012Zm34.425-15.244a1.329,1.329,0,0,1-.581,1l-14.29,9.684a8.362,8.362,0,0,1-4.923,1.454l-12.67-.275-4.789-9.578,4.506-1.846a14.011,14.011,0,0,1,10.608-.03l4.352,1.755a1.515,1.515,0,0,1,.9,1.775A1.712,1.712,0,0,1,101.179,240c-.023,0-.046,0-.069-.008l-8-1.364a1.28,1.28,0,0,0-.43,2.524l.292.05-.012.078s4.576.731,7.642,1.228c.06.01.119.015.179.022a7.949,7.949,0,0,0,5.649-1.286l11.338-7.684a1.334,1.334,0,0,1,2.077,1.211Z",
    transform: "translate(-36.664 574.711)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1563",
    "data-name": "Group 1563",
    transform: "translate(52.454 780.01)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_706",
    "data-name": "Path 706",
    d: "M11.808,4.276A1.528,1.528,0,0,1,13.315,3h3.521a1.528,1.528,0,0,1,1.507,1.276l.289,1.739A1.7,1.7,0,0,0,19.508,7.2c.1.054.2.113.3.172a1.688,1.688,0,0,0,1.46.168l1.652-.619a1.528,1.528,0,0,1,1.86.665l1.76,3.051a1.528,1.528,0,0,1-.353,1.943L24.824,13.7a1.686,1.686,0,0,0-.585,1.347q0,.173,0,.346a1.685,1.685,0,0,0,.584,1.344l1.365,1.124a1.529,1.529,0,0,1,.353,1.942l-1.762,3.051a1.528,1.528,0,0,1-1.859.667L21.267,22.9a1.692,1.692,0,0,0-1.461.168q-.148.09-.3.174a1.693,1.693,0,0,0-.874,1.18l-.289,1.738a1.528,1.528,0,0,1-1.507,1.278H13.314a1.528,1.528,0,0,1-1.507-1.276l-.289-1.739a1.691,1.691,0,0,0-.874-1.181q-.151-.083-.3-.172A1.691,1.691,0,0,0,8.883,22.9l-1.652.619a1.528,1.528,0,0,1-1.859-.665L3.611,19.806a1.528,1.528,0,0,1,.353-1.943L5.327,16.74a1.689,1.689,0,0,0,.584-1.347q0-.173,0-.346A1.685,1.685,0,0,0,5.327,13.7L3.964,12.578a1.528,1.528,0,0,1-.353-1.942L5.372,7.585a1.528,1.528,0,0,1,1.86-.667l1.651.619a1.691,1.691,0,0,0,1.461-.168c.1-.06.2-.118.3-.174a1.686,1.686,0,0,0,.874-1.18l.291-1.739Z",
    transform: "translate(-3.406 -3)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_707",
    "data-name": "Path 707",
    d: "M17.147,13.074A4.074,4.074,0,1,1,13.074,9,4.074,4.074,0,0,1,17.147,13.074Z",
    transform: "translate(-1.405 -0.853)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconServices, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-services.052953b8.svg";
export { ForwardRef as ReactComponent };